import { Trans, useTranslation } from 'next-i18next';
import { SquareStackIcon } from '@/icons';
import { Button } from '@/ui_v3';
interface GuestCopyGuideOverlayProps {
  onCopy: () => void;
}
export const GuestCopyGuideOverlay = ({
  onCopy
}: GuestCopyGuideOverlayProps) => {
  const {
    t
  } = useTranslation(['common']);
  return <div className="absolute inset-0 z-10 flex flex-col items-center justify-center gap-lg rounded-md bg-neutral/80 p-lg backdrop-blur-[7.5px]" data-sentry-component="GuestCopyGuideOverlay" data-sentry-source-file="GuestCopyGuideOverlay.tsx">
      <p className="max-w-[361px] whitespace-pre-line text-center text-heading-lg-extrabold text-default">
        <Trans t={t} i18nKey="shareModal.guestSave.title" components={{
        highlight: <span className="text-strong" />
      }} data-sentry-element="Trans" data-sentry-source-file="GuestCopyGuideOverlay.tsx" />
      </p>
      <Button variant="contained" intent="gradient" size="lg" rounded="full" leftSlot={<SquareStackIcon />} onClick={onCopy} data-sentry-element="Button" data-sentry-source-file="GuestCopyGuideOverlay.tsx">
        {t('shareModal.guestSave.button')}
      </Button>
    </div>;
};